<template>
  <div class="pint90x95">
    <div class="label-content">
      <div class="name">商品名：
        <br>
        {{ printData.name }}
      </div>
      <div class="head">
        <div class="left">
          <div class="material">
            <div v-html="printData.material"></div>
          </div>
          <div class="name">お取り扱い上のご注意：</div>
        </div>
        <div class="right">
          <canvas id="barcode"></canvas>
        </div>
      </div>
      <div class="content">
        <div class="desc">
          <div v-html="printData.desc"></div>
        </div>
      </div>
      <div class="company">
        <div v-html="printData.company"></div>
      </div>

    </div>
  </div>
</template>

<script>
import JsBarcode from 'jsbarcode'

export default {
  props: {
    printData: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {}
  },
  mounted() {
    this.generateBarcode(this.printData.barcode)
  },
  methods: {
    generateBarcode(barcode) {
      JsBarcode('#barcode', barcode, {
        format: 'EAN13', //选择要使用的条形码类型
        displayValue: true,
        margin: 10,
        width: 3.5,
        fontSize: 35,//设置文本的大小
        fontWeight: 'bold',//设置文本的大小
        lineColor: "#000000",//设置条和文本的颜色。
        fontOptions: 'bold',
        height: 120,
      })
    },
  }
}
</script>

<style scoped lang="scss">
.pint90x95 {

  margin: 0 auto;
  padding: 30px;
  box-sizing: border-box;
  background-color: #fff;

  .label-content {
    width: 980px;

    padding: 20px;
    box-sizing: border-box;
    background-color: #fff;

    font-size: 28px;

    .head {
      display: flex;
      justify-content: space-between;
    }

    .name {
      margin-bottom: 25px;
    }

    .material {
      line-height: 55px;
      margin-bottom: 10px;
    }

    .content {
      .desc {
        font-size: 22px;
        margin-top: 10px;
      }
    }

    .company {
      margin-top: 50px;
      font-size: 22px;
    }

  }
}
</style>